export default __webpack_public_path__ + "c08362599592ea9b7258519ce9a1f4ae.png";